import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  height: 60px;
  padding-left: var(--mantine-spacing-md);
  padding-right: var(--mantine-spacing-md);
  border-bottom: 1px solid light-dark(var(--mantine-color-dark-3), var(--mantine-color-dark-4));
  transition: height 200ms ease;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;

  --mantine-color-dark-6: transparent;
`;

export const Gap = styled.div`
  flex: 1;
`;

export const Right = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
`;
